import { useState, useEffect } from "react";
import { getPage } from "../services/page.service";
import { REGION_UUID } from "modules/core/constants";

export const usePage = (pageUuid: string) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [page, setPage] = useState<Awaited<ReturnType<typeof getPage>>>();

  useEffect(() => {
    getPage(REGION_UUID, pageUuid)
      .then((data) => {
        setPage(data);
        setIsLoaded(true);
      })
      .catch(console.error);
  }, []);

  return { isLoaded, page };
};
